module.exports = __webpack_public_path__ + "assets/img/activity-js.a38075b6.png";